import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import SignIn from '../../components/signin';
import userManager from '../../utils/userManager';
import { at } from '../../utils/helpers';

class SignInContainer extends Component {
  render() {
    const { location, isSignedIn } = this.props;
    const redirectUrl = at(location, 'state.referrer') || '/';
    return !isSignedIn ? (
      <SignIn
        onClick={() => userManager.signinRedirect({ data: { redirectUrl } })}
      />
    ) : (
      <Redirect to={redirectUrl || window.location.origin} />
    );
  }
}

const mapStateToProps = ({ oidc }) => {
  return {
    isSignedIn: oidc.user,
  };
};

export default connect(mapStateToProps)(SignInContainer);
